export default class ValidationError {
    public readonly error: string;
    public readonly element: string;

    constructor(element: string, error: string) {
        this.element = element;
        this.error = error;
    }
}
